/**
 * Typed wrappers over the console-only `localStorage` debug flags the app's
 * various subsystems already read directly (`=== "1"`). Surfacing them as real
 * toggles in Settings → Developer means a tester never has to open a console.
 * No consumer changes are needed — they keep reading the same keys.
 */

export type DevFlag = "notifyDebug" | "gsyncDebug" | "inkDebug" | "mobileUx";

export const DEV_FLAGS: { key: DevFlag; label: string; desc: string; needsReload?: boolean }[] = [
  { key: "notifyDebug", label: "Notification logging", desc: "Logs reminder scheduling, permission checks and per-stage counts to the console." },
  { key: "gsyncDebug", label: "Google sync logging", desc: "Logs bound calendars and per-calendar pull/push stats to the console." },
  { key: "inkDebug", label: "Ink animation tracing", desc: "Traces the task-form watercolor ink pipeline (emit → spawn → settle)." },
  { key: "mobileUx", label: "Force mobile UX", desc: "Use the phone-style touch UX in this desktop browser.", needsReload: true },
];

export function getDevFlag(key: DevFlag): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(key) === "1";
}

export function setDevFlag(key: DevFlag, on: boolean): void {
  if (typeof window === "undefined") return;
  if (on) localStorage.setItem(key, "1");
  else localStorage.removeItem(key);
}
